<template>
  <pop-up-layout 
    :title="$t('reservas.documentacion.tituloDocumentacionError')"
    :ocultarVolver="true"
  >
    <v-layout column justify-center align-center my-4>
      <o-base-center-text>
        <v-flex>
          <span>
            {{$t('reservas.documentacion.avisoProceso')}}
          </span>
          <p v-if="!incrustado">
            {{$t('reservas.documentacion.avisoEmailIncrustado')}}
          </p>
          <p v-else>
            {{$t('reservas.documentacion.avisoEmail')}}
          </p>
        </v-flex>
      </o-base-center-text>
    </v-layout>
      <v-layout mb-3 justify-center>
        <v-icon color="primary" class="custom-icon icon-job" style="font-size:200px;"/>
      </v-layout>
      <v-layout justify-center>
        <v-btn 
          large color="primary"
          @click="$emit('continuar')"
          :disabled="cargandoExterior"
          :loading="cargandoExterior"
        >
          {{$t('reservas.documentacion.aceptar')}}
        </v-btn>
      </v-layout>
  </pop-up-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario'
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/documentacion/DocumentacionErrorContrato.vue